<template>
  <div class="quick-wrap" v-show="show" @touchmove.prevent>
    <div class="quick-order">
      <div class="icon-close" @click="close">
        <span class="iconfont icon1">&#xe614;</span>
        <span class="iconfont icon2">&#xe606;</span>
      </div>
      <!-- 这个地方写两句代码，是因为传进来的错误有可能是数组，有可能只是单独的一句话(字符串) -->
      <div v-show="Array.isArray(content)" class="remark" v-for="item,i in content" :key="i">{{item}}</div>
      <div v-show="!Array.isArray(content)">{{content}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name:'AddCartErr',
  data() {
    return {
      show:false,
      content:[]
    }
  },
  methods:{
    open(content){
      this.show=true
      this.content=content
    },
    close(){
      this.show=false
    }
  }
}
</script>

<style lang="less" scoped>
@import url('../../public/css/public.less');
/* 快速下单 */
.quick-wrap{
  position: fixed;
  left:0;
  top:0;
  width:100%;
  height:100%;
  z-index: 999;
  background-color: rgba(0,0,0,0.6);
  overflow: hidden;
  .quick-order{
    border-radius: 2px;
    position: absolute;
    &:extend(.main-box-shadow);
    width:500px;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background-color: #fff;
    padding:40px;
    box-sizing: border-box;
    text-align: left;
    .icon-close{
      // background-color: red;
      position: absolute;
      right:14px;
      top:14px;
      .icon1{
        font-size: 24px;
        display: block;
        color:#888;
      }
      .icon2{
        font-size: 24px;
        display: none;
        color:@mainColor;
      }
      &:hover{
        cursor: pointer;
        .icon1{
          display: none;
        }
        .icon2{
          display: block;
        }
      }
    }
    .remark{
      text-align: left;
      margin-top: 16px;
    }
  }
}

</style>